var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e(),_c('div',{staticStyle:{"min-width":"1200px","min-height":"700px"},attrs:{"id":"happy-chart"}}),_c('div',{staticStyle:{"min-width":"1200px","min-height":"700px"},attrs:{"id":"kress-chart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }